module.exports = __webpack_public_path__ + "img/u218.b143cc6f.png";